import axios from "axios";

const apiFarms = axios.create({
  // baseURL: "http://localhost:8082",
  baseURL: process.env.REACT_APP_BOVEXO_FARMS_URL,
  validateStatus: (status) => status >= 200 && status < 300,
});

export default apiFarms;
